import { useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "../ui/dialog";
import { Input } from "../ui/input";
import { adminApi, errorMessage } from "../../lib/api";

export const DeleteLeadDialog = ({ kind, lead, onClose, onDeleted }) => {
  const [typed, setTyped] = useState("");
  const [busy, setBusy] = useState(false);
  if (!lead) return null;
  const remove = async () => {
    setBusy(true);
    try {
      await adminApi.delete(`/admin/leads/${kind}/${lead.id}`, { data: { confirm_reference: typed } });
      toast.success(`${lead.reference} removed permanently`);
      onDeleted();
    } catch (e) {
      toast.error(errorMessage(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <Dialog open onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent data-testid="delete-lead-dialog" className="rounded-none border-red-500/40 bg-[#0F172A] text-slate-100">
        <DialogHeader>
          <DialogTitle className="font-heading text-xl text-white">Remove {lead.company_name || lead.full_name}?</DialogTitle>
          <DialogDescription className="text-slate-300">
            This permanently deletes the {kind} record, KYC documents, matches{kind === "worker" ? ", contact unlocks and pending joinings" : " for this requirement (the employer's wallet account stays)"}. It cannot be undone.
          </DialogDescription>
        </DialogHeader>
        <p className="text-sm text-slate-400">Type <span className="font-mono text-red-300">{lead.reference}</span> to confirm:</p>
        <Input value={typed} onChange={(e) => setTyped(e.target.value)} data-testid="delete-lead-confirm-input"
          className="h-11 rounded-none border-white/10 bg-[#0B1120] font-mono" placeholder={lead.reference} />
        <div className="flex justify-end gap-2">
          <button onClick={onClose} data-testid="delete-lead-cancel" className="border border-white/15 px-5 py-2.5 text-sm">Cancel</button>
          <button disabled={busy || typed.trim().toUpperCase() !== lead.reference} onClick={remove} data-testid="delete-lead-confirm-button"
            className="bg-red-600 px-5 py-2.5 text-sm font-semibold text-white hover:bg-red-500 disabled:opacity-40">Remove permanently</button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
